import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZalandoComponent } from './simple-icons-zalando.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZalandoComponent ],
    exports:      [ SimpleIconsZalandoComponent ],
    bootstrap:    []
})
export class SimpleIconsZalandoModule {}
